import * as Sentry from '@sentry/react';
import * as React from 'react';

import mp3Notification from '../../assets/audio/call_notification.mp3';
import wavNotification from '../../assets/audio/call_notification.wav';

const NOTIFICATION_VOLUME = 0.2;
const NOTIFICATION_ID = 'call_notification';

const audioLockedState = {
  userInteracted: false,
  loaded: false
};

export const playNotificationSound = () => {
  const audioElement = document.getElementById(NOTIFICATION_ID) as HTMLAudioElement;
  if (audioElement && audioLockedState.userInteracted && audioLockedState.loaded) {
    audioElement.play().catch(() => {
      audioElement.play().catch(playError => {
        // eslint-disable-next-line no-console
        console.error('Error playing notification sound in retry:', playError);
        if (!(playError instanceof DOMException && playError.name === 'AbortError')) {
          Sentry.captureException(playError);
        }
      });
    });
  }
};

const AudioNotification = () => {
  const audioCallbackRef = React.useCallback((audioNode: HTMLAudioElement | null) => {
    if (!audioNode) {
      audioLockedState.userInteracted = false;

      return;
    }

    window.addEventListener(
      'click',
      () => {
        audioLockedState.userInteracted = true;
      },
      { once: true }
    );

    audioNode.volume = NOTIFICATION_VOLUME;
    audioNode.addEventListener('canplaythrough', () => {
      audioLockedState.loaded = true;
    });
  }, []);

  return (
    <audio
      ref={audioCallbackRef}
      id={NOTIFICATION_ID}
      aria-label="Notification sound"
      style={{ display: 'none' }}
      preload="auto"
    >
      <source src={mp3Notification} type="audio/mp3" />
      <source src={wavNotification} type="audio/wav" />
    </audio>
  );
};

export default React.memo(AudioNotification);
